<a
  href="javascript:void(0)"
  *ngIf="
    isWebshopCartInit &&
    option &&
    !loading &&
    option.trialOption &&
    active &&
    deepLinkStatus !== DeepLinkStatus.DEEPLINK_SEVERAL_PRODUCTS_ELIGIBLE &&
    deepLinkStatus !== DeepLinkStatus.DEEPLINK_OPTION_ORDERING_INCOMPATIBLE
  "
  class="rs-btn"
  [ngClass]="[
    disableButtonClass,
    this.productType === 'tv' &&
    (disableButtonClass || option.trialOption.endOfTrialDecision === 'CTP')
      ? 'rs-btn-neg'
      : '',
    option.trialOption.endOfTrialDecision !== 'CTP' ? 'rs-btn-order' : ''
  ]"
  (click)="addToCart()"
>
  {{
    (option.trialOption.endOfTrialDecision === "CTP"
      ? "option.details.try-and-buy.deactivate-after-trial"
      : "option.details.try-and-buy.activate-after-trial"
    ) | translate
  }}
</a>

<a
  href="javascript:void(0)"
  *ngIf="
    isWebshopCartInit &&
    option &&
    !loading &&
    !option.trialOption &&
    active &&
    option.isCeasable && 
    deepLinkStatus !== DeepLinkStatus.DEEPLINK_SEVERAL_PRODUCTS_ELIGIBLE &&
    deepLinkStatus !== DeepLinkStatus.DEEPLINK_OPTION_ORDERING_INCOMPATIBLE
  "
  class="rs-btn"
  [ngClass]="[negativeButtonClass, disableButtonClass]"
  (click)="addToCart()"
  >{{ ceaseLabelKey | translate }}
</a>

<!--Order button option -->
<a
  href="javascript:void(0)"
  *ngIf="
    isWebshopCartInit &&
    option &&
    !loading &&
    (!isNimbleRedirection ||
    (isNimbleRedirection && isWebshopLoaded)) &&
    (!active ||
      (active && !option.isCeasable)) &&
    deepLinkStatus !== DeepLinkStatus.DEEPLINK_SEVERAL_PRODUCTS_ELIGIBLE &&
    deepLinkStatus !== DeepLinkStatus.DEEPLINK_OPTION_ORDERING_INCOMPATIBLE
  "
  class="rs-btn"
  (click)="addToCart()"
  [ngClass]="[
    isSwap ? '' : 'rs-btn-order',
    disableButtonClass,
    this.productType === 'tv' && disableButtonClass ? 'rs-btn-neg' : ''
  ]"
>
  {{
    (option.trialOption ? "option.details.try-and-buy.order" : orderLabelKey)
      | translate
  }}
</a>

<a
  href="javascript:void(0)"
  *ngIf="
    isWebshopCartInit &&
    !loading &&
    (deepLinkStatus === DeepLinkStatus.DEEPLINK_OPTION_ORDERING_INCOMPATIBLE ||
      deepLinkStatus === DeepLinkStatus.DEEPLINK_NO_PRODUCTS)
  "
  class="rs-btn"
  [ngClass]="[negativeButtonClass, disableButtonClass]"
>
  {{ "option.details.incompatible" | translate }}
</a>

<a
  href="javascript:void(0)"
  *ngIf="
    !loading &&
    deepLinkStatus === DeepLinkStatus.DEEPLINK_SEVERAL_PRODUCTS_ELIGIBLE &&
    !triggerAddToCartFromSelector
  "
  class="rs-btn rs-btn-order"
  [ngClass]="disableButtonClass"
  (click)="openDeepLinkProductSelectionPopup()"
  >{{ "option.details.order.popup" | translate }}
</a>

<a
  href="javascript:void(0)"
  *ngIf="isWebshopCartInit && loading  && !(isNimbleRedirection && !isWebshopLoaded)"
  class="rs-btn rs-btn-waiting rs-btn-large"
  [ngClass]="negativeButtonClass"
  >{{
    (option.trialOption?.endOfTrialDecision === "CTP" || active
      ? "option.details.ceasing"
      : "option.details.loading"
    ) | translate
  }}
  <div class="rs-btn-waiting-dots" [ngClass]="negativeButtonClass"></div>
</a>

<a
  href="javascript:void(0)"
  *ngIf="
    (!isWebshopCartInit &&
      deepLinkStatus !==  DeepLinkStatus.DEEPLINK_SEVERAL_PRODUCTS_ELIGIBLE) ||
    triggerAddToCartFromSelector
  "
  class="rs-btn rs-btn-waiting"
  [ngClass]="negativeButtonClass"
>
  <div class="rs-btn-waiting-dots"></div>
  &nbsp;
</a>

